import React, { useState } from 'react';
import { MoreVert } from '@material-ui/icons';
import { Menu, Tooltip } from '@mui/material';
import * as Styles from './RegulationActions.styles';
import { IRegulationActionsProps } from './RegulationActions.types';
import UploadRegulationMenuItem from './components/UploadRegulationMenuItem/UploadRegulationMenuItem';
import DownloadRegulationMenuItem from './components/DownloadRegulationMenuItem/DownloadRegulationMenuItem';

const RegulationActions = ({ inspection }: IRegulationActionsProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Styles.IconButton data-testid="show-more-button" onClick={handleClick}>
        <Tooltip title="Ações">
          <MoreVert />
        </Tooltip>
      </Styles.IconButton>
      <Menu data-testid="menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        <UploadRegulationMenuItem inspection={inspection} />
        <DownloadRegulationMenuItem inspection={inspection} onCloseMenu={handleClose} />
      </Menu>
    </>
  );
};

export default RegulationActions;
